module.exports = __webpack_public_path__ + "img/loading_icon.8234e343.png";